export const theme = {
  colors: {
    bg: 'white',
    border: 'gray.200'
  },
  layout: {
    maxWidth: '1200px',
    pageMaxWidth: '800px'
  }
} as const;